export const getApplicationBreadcrumbs = (title) => {
    const crumbs = [
        { pathname: "/applications", crumbLabel: "Application Gallery" },
        { crumbLabel: title },
    ];

    return crumbs;
};

export const getCaseStudyBreadcrumbs = (title) => {
    const crumbs = [
        { pathname: "/applications", crumbLabel: "Applications" },
        { pathname: "/applications/case-studies", crumbLabel: "Case Studies" },
        { crumbLabel: title },
    ];

    return crumbs;
};

export const getEventBreadcrumbs = (eventName) => {
    const crumbs = [
        { pathname: "/events", crumbLabel: "Events" },
        { crumbLabel: eventName },
    ];

    return crumbs;
};

export const getNewsBreadcrumbs = (newsTitle) => {
    const crumbs = [
        { pathname: "/news", crumbLabel: "News" },
        { crumbLabel: newsTitle },
    ];

    return crumbs;
};

export const getArticleBreadcrumbs = (articleTopic, articleName) => {
    const crumbs = [{ pathname: "/insights", crumbLabel: "Lighting Insights" }];

    if (articleTopic) {
        crumbs.push({
            pathname: articleTopic.link,
            crumbLabel: articleTopic.name,
        });
    }

    if (articleName) {
        crumbs.push({
            crumbLabel: articleName,
        });
    }

    return crumbs;
};

export const getArticleTopicBreadcrumbs = (articleTopic) => {
    const crumbs = [{ pathname: "/insights", crumbLabel: "Lighting Insights" }];

    if (articleTopic) {
        crumbs.push({
            pathname: articleTopic.link,
            crumbLabel: `Topic: ${articleTopic.name}`,
        });
    }

    return crumbs;
};

export const getArticleTagBreadcrumbs = (articleTag) => {
    const crumbs = [{ pathname: "/insights", crumbLabel: "Lighting Insights" }];

    if (articleTag) {
        crumbs.push({
            pathname: articleTag.link,
            crumbLabel: `Tag: ${articleTag.name}`,
        });
    }

    return crumbs;
};

export const getProductBreadcrumbs = (
    productName,
    location,
    productCategories,
) => {
    const categories = productCategories.nodes;
    const crumbs = [
        {
            pathname: `/products/`,
            crumbLabel: "Products",
        },
    ];

    const [, , topLevel, secondLevel] = location.pathname.split("/");

    if (topLevel && secondLevel && categories?.length) {
        const topCat = categories.find(({ slug }) => slug === topLevel);
        const secondCat = categories.find(({ slug }) => slug === secondLevel);

        if (topCat && secondCat) {
            crumbs.push({
                pathname: topCat.uri,
                crumbLabel: topCat.name,
            });

            crumbs.push({
                pathname: secondCat.uri,
                crumbLabel: secondCat.name,
            });
        }
    }

    if (productName) {
        crumbs.push({
            crumbLabel: productName,
        });
    }

    return crumbs;
};

export const getProductCategoryBreadcrumbs = (ancestors, categoryName) => {
    const crumbs = [
        {
            pathname: `/products/`,
            crumbLabel: "Products",
        },
    ];

    if (ancestors?.length) {
        const reverseAncestors = ancestors.map(
            (_, idx) => ancestors[ancestors.length - 1 - idx],
        );

        reverseAncestors.forEach(({ name, uri }) => {
            crumbs.push({
                pathname: uri,
                crumbLabel: name,
            });
        });
    }

    crumbs.push({
        crumbLabel: categoryName,
    });

    return crumbs;
};

export const getPageBreadcrumbs = (pages, pageTitle) => {
    const crumbs = [];

    if (Array.isArray(pages)) {
        const reversePages = pages.map(
            (_, idx) => pages[pages.length - 1 - idx],
        );

        reversePages.forEach(({ title, uri }) => {
            const withoutQueryVars = uri.split("?")[0];
            const newUrl = `${withoutQueryVars}`;

            crumbs.push({
                pathname: newUrl,
                crumbLabel: title,
            });
        });
    }

    crumbs.push({
        crumbLabel: pageTitle,
    });

    return crumbs;
};
